module.exports = __webpack_public_path__ + "static/media/backgroundBottom.68f78df1.png";